import { localStore } from "helpers";
import APIManager from "modules/common/apiManager";
import {
  ButtonCommonTheme,
  ControlLabel,
  FormControl,
  InsightFilter,
  SelectFilterAPI,
  Spinner,
} from "modules/theme";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment-timezone";
import PropTypes from "prop-types";
import React from "react";
import Datetime from "react-datetime";
import Select from "react-select-plus";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";
import { FlexItem } from "../../../../screens/reporting/styles";
import { ModalForm } from "../styles/main";
import { timezones } from "./timezones";
import CommonManager from "../../../../../helpers/common";
import { connect } from "react-redux";
import { globalStateSelector } from "../../../../../store/selector";

const commonManager = new CommonManager();

const SelectStyle = styled.div`
  width: 100%;

  .Select-value {
    margin-top: 2px;
  }

  .Select-placeholder {
    margin-top: 2px;
  }

  .Select-multi-value-wrapper {
    width: 90%;
  }

  .Select-arrow-zone {
    width: 10%;
  }

  .Select-clear-zone {
    width: 10%;
  }

  .Select-clear {
    margin: 0;
  }

  .Select-placeholder,
  .Select-input,
  .Select--single > .Select-control .Select-value {
    padding-left: 15px !important;
  }
  .Select.is-focused .Select-input > input {
    padding: 12px 0 12px !important;
  }
  .Select--multi .Select-input {
    margin-left: -12px !important;
  }
  .Select--multi .Select-multi-value-wrapper {
    padding: 0 12px !important;
  }
`;

const FormStyle = styled.div`
  width: 100%;
  input {
    padding: 0;
    padding-left: 10px;
  }

  input::placeholder {
    color: #aaa;
  }
`;

const contextTypes = {
  __: PropTypes.func,
  closeModal: PropTypes.func.isRequired,
};

class CommonFilter extends React.Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    let zone = commonManager.getTimeZone();
    let queryParams = props.queryParams || {};
    let time = this.getDefaultTime(zone);
    let selectedValues = props.selectedValues || {};

    this.state = {
      isLoading: false,
      isChange: false,
      isSummary:
        this.props.reportName && this.props.reportName.search(/Summary/i),
      // selectedValues: props.filter || {},
      reportType: props.reportType,
      selectedValues,
      selectedColumns: [],
      DatesBy: null,
      timezone: zone,
      filter: {},
      dataFilter: {},
      showHide: false,
      sendStartTime: (selectedValues && selectedValues.sendStartTime) || "",
      sendEndTime: (selectedValues && selectedValues.sendEndTime) || "",
      showStartEndDate:
        selectedValues && selectedValues.DatesBy === "Custom Date"
          ? true
          : false,
      ...queryParams,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.resetAllData = this.resetAllData.bind(this);
    this.renderTimezones = this.renderTimezones.bind(this);
    this.renderDropdown = this.renderDropdown.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
  }

  componentDidMount() {
    let zone = commonManager.getTimeZone();
    const { startDate, endDate } = commonManager.calculateTimeRange(
      "Today",
      zone
    );
    this.setState({
      timezone: zone,
      sendEndTime:
        (this.props.selectedValues && this.props.selectedValues.sendEndTime) ||
        endDate,
    });
  }

  getDefaultTime(zone) {
    let time = {};
    try {
      time.sendStartTime =
        parseInt(
          moment()
            .endOf("day")
            .tz(zone.value)
            .format("X")
        ) * 1000;
      time.sendEndTime =
        parseInt(
          moment()
            .subtract(30, "days")
            .tz(zone.value)
            .format("X")
        ) * 1000;
    } catch (err) {
      console.log("error in timezone", err);
    }
    return time;
  }
  componentWillReceiveProps(nextProps) {
    let result = nextProps.getSelectedColumnNames();
    this.setState({ isLoading: false });
  }

  getOnlyValue(arrOfObj, tData) {
    if (
      tData[arrOfObj] &&
      tData[arrOfObj].length > 0 &&
      typeof tData[arrOfObj][0] === "object"
    )
      tData[arrOfObj] = tData[arrOfObj].map((item) => item.value);
  }

  onSubmit = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
      this.setState({ isLoading: true });
    }

    if (this.state.timezone) {
      localStore.setItem("timezone", JSON.stringify(this.state.timezone));
    }

    let tData = {
      ...this.state.selectedValues,
      timezone: this.state.timezone,
      sendStartTime: this.state.sendStartTime,
      sendEndTime: this.state.sendEndTime,
      startDate: this.state.sendStartTime,
      endDate: this.state.sendEndTime,
    };

    // const oldTdata = cloneDeep(tData)
    // console.log('oldtdata',oldTdata)
    this.setState({
      selectedValues: tData,
    });
    this.props.getData(tData);
    // this.getOnlyValue('userIds',tData);
    // this.getOnlyValue('agentId',tData);
    // this.getOnlyValue('stickyAgent',tData);
    // this.getOnlyValue('breakIds',tData);
    // this.getOnlyValue('campaignIds',tData);
    // this.getOnlyValue('desposeIds',tData);
    // this.getOnlyValue('contactListIds',tData);
    // this.getOnlyValue('teamIds',tData);
    // this.getOnlyValue('tagIds',tData);
  };

  generateProjectParams(tData) {
    return tData.map((data) => ({
      value: data._id,
      label: data.name || "",
    }));
  }
  generateEntitysParams(supportedEntityList) {
    return supportedEntityList.map((entity) => ({
      value: entity,
      label: entity,
    }));
  }

  renderTimezonesOnly() {
    const { __ } = this.context;
    var that = this;
    return (
      <div className="filter-row mb-3 px-5">
        <ControlLabel>Timezone</ControlLabel>
        <SelectStyle>
          <Select
            placeholder={__("Select Timezone")}
            clearable={false}
            onChange={(selectedOption) => {
              if (selectedOption && selectedOption !== null) {
                that.setState({
                  timezone: selectedOption,
                });
              }
            }}
            value={this.state.timezone}
            options={timezones}
          />
        </SelectStyle>
      </div>
    );
  }

  renderTimezonesFuture() {
    const { __ } = this.context;
    var that = this;
    let zone = commonManager.getTimeZone();

    return (
      <React.Fragment>
        <div className="filter-row mb-3 px-5">
          <ControlLabel>Timezone</ControlLabel>
          <SelectStyle>
            <Select
              placeholder={__("Select Timezone")}
              clearable={false}
              onChange={(selectedOption) => {
                if (selectedOption && selectedOption !== null) {
                  const {
                    startDate,
                    endDate,
                  } = commonManager.calculateTimeRange(
                    this.state.DatesBy || this.state.selectedValues.DatesBy,
                    selectedOption
                  );
                  that.setState({
                    sendStartTime: startDate,
                    sendEndTime: endDate,
                    timezone: selectedOption,
                  });
                }
              }}
              value={this.state.timezone}
              options={timezones}
            />
          </SelectStyle>
        </div>

        <div className="filter-row mb-3 px-5">
          <ControlLabel>Select By Date</ControlLabel>
          <SelectStyle>
            <Select
              value={this.state.selectedValues.DatesBy || null}
              defaultValue={"Date"}
              placeholder={__("Select Dates")}
              clearable={this.state.isSummary !== -1 ? false : true}
              options={this.generateEntitysParams([
                "Today",
                "Next 24 Hours",
                "Tomorrow",
                "Next 7 Days",
                "Custom Date",
              ])}
              onChange={(items) => {
                let selected = items && items.value ? items.value : "";
                if (!selected) {
                  const {
                    startDate,
                    endDate,
                  } = commonManager.calculateTimeRange("Today", zone);
                  this.setState({
                    showStartEndDate: false,
                    startDate,
                    endDate,
                    sendStartTime: startDate,
                    sendEndTime: endDate,
                    DatesBy: null,
                    selectedValues: {
                      ...this.state.selectedValues,
                      DatesBy: null,
                    },
                  });
                  return;
                }
                const { startDate, endDate } = commonManager.calculateTimeRange(
                  selected,
                  this.state.timezone || zone
                );
                let showStartEndDate = false;
                if (selected == "Custom Date") {
                  showStartEndDate = true;
                }
                this.setState({
                  showStartEndDate,
                  startDate,
                  endDate,
                  sendStartTime: startDate,
                  sendEndTime: endDate,
                  selectedValues: {
                    ...this.state.selectedValues,
                    DatesBy: selected || null,
                  },
                  DatesBy: selected,
                });
              }}
            />
          </SelectStyle>
        </div>

        {this.state.showStartEndDate && (
          <div
            className="row w-100 px-4 py-4 m-0 mb-3"
            style={{
              backgroundColor: "#f2f2f2",
            }}
          >
            <div className="filter-row mb-3 col-md-6">
              <FlexItem>
                <ControlLabel>Start date</ControlLabel>
                <Datetime
                  inputProps={{ readOnly: true }}
                  value={this.state.sendStartTime}
                  onChange={(date) => {
                    if (
                      parseInt(
                        moment(date)
                          .tz(zone.value)
                          .format("X")
                      ) *
                      1000 <
                      this.state.sendEndTime
                    )
                      that.setState(
                        {
                          sendStartTime:
                            parseInt(
                              moment(date)
                                .tz(zone.value)
                                .format("X")
                            ) * 1000,
                        },
                        () => {
                        }
                      );
                  }}
                />
                <span
                  class="icon material-symbols-outlined"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "30px",
                    color: "#D9D9D9",
                  }}
                >
                  calendar_month
                </span>
              </FlexItem>
            </div>
            <div className="filter-row mb-3 col-md-6">
              <FlexItem>
                <ControlLabel>End date</ControlLabel>
                <Datetime
                  className="datatime-wrapper datetime-wrapper-move-left"
                  inputProps={{ readOnly: true }}
                  value={this.state.sendEndTime}
                  onChange={(date) => {
                    if (
                      parseInt(
                        moment(date)
                          .tz(zone.value)
                          .format("X")
                      ) *
                      1000 >
                      this.state.sendStartTime
                    ) {
                      this.setState({
                        sendEndTime:
                          parseInt(
                            moment(date)
                              .tz(zone.value)
                              .format("X")
                          ) * 1000,
                      });
                    }
                  }}
                />
                <span
                  class="icon material-symbols-outlined"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "30px",
                    color: "#D9D9D9",
                  }}
                >
                  calendar_month
                </span>
              </FlexItem>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
  renderTimezones() {
    const { __ } = this.context;
    var that = this;
    let zone = commonManager.getTimeZone();
    const filterDurationOptions = [
      { value: "today", label: "Today" },
      { value: "last24", label: "Last 24 Hrs" },
      { value: "lastweek", label: "Last 7 Days" },
      { value: "all", label: null },
    ];
    let filterDuration = localStorage.getItem("filterDuration");
    const filterDurationObject = filterDurationOptions.find(
      (item) => item.value === filterDuration
    );

    const initialDatesBy =
      filterDuration && filterDurationObject && filterDurationObject.label;

    return (
      <React.Fragment>
        <div className="filter-row mb-3 px-5">
          <ControlLabel>Timezone</ControlLabel>
          <SelectStyle>
            <Select
              placeholder={__("Select Timezone")}
              clearable={false}
              onChange={(selectedOption) => {
                if (selectedOption && selectedOption !== null) {
                  const {
                    startDate,
                    endDate,
                  } = commonManager.calculateTimeRange(
                    this.state.DatesBy || this.state.selectedValues.DatesBy,
                    selectedOption
                  );
                  that.setState({
                    sendStartTime: startDate,
                    sendEndTime: endDate,
                    timezone: selectedOption,
                  });
                }
              }}
              value={this.state.timezone}
              options={timezones}
            />
          </SelectStyle>
        </div>

        <div className="filter-row mb-3 px-5">
          <ControlLabel>Select By Date</ControlLabel>
          <SelectStyle>
            <Select
              // key={`${uuidv4()}entity`}
              value={
                this.props.editData
                  ? this.state.selectedValues.DatesBy
                  : this.state.selectedValues.DatesBy === null
                    ? null
                    : this.state.selectedValues.DatesBy || initialDatesBy
              }
              defaultValue={"Date"}
              placeholder={__("Select Dates")}
              clearable={this.state.isSummary !== -1 ? false : true}
              options={this.generateEntitysParams([
                "Today",
                "Last 24 Hrs",
                "Yesterday",
                "Last 7 Days",
                "Custom Date",
              ])}
              onChange={(items) => {
                let selected = items && items.value ? items.value : "";
                if (!selected) {
                  const {
                    startDate,
                    endDate,
                  } = commonManager.calculateTimeRange("Today", zone);
                  const isSummary = this.state.isSummary;
                  const setToday = isSummary && isSummary !== -1 ? true : false;
                  this.setState({
                    showStartEndDate: false,
                    startDate: setToday ? startDate : "",
                    endDate: setToday ? endDate : "",
                    sendStartTime: setToday ? startDate : "",
                    sendEndTime: setToday ? endDate : "",
                    DatesBy: setToday ? "Today" : null,
                    selectedValues: {
                      ...this.state.selectedValues,
                      DatesBy: setToday ? "Today" : null,
                    },
                  });
                  return;
                }
                const { startDate, endDate } = commonManager.calculateTimeRange(
                  selected,
                  this.state.timezone || zone
                );
                let showStartEndDate = false;
                if (selected == "Custom Date") {
                  showStartEndDate = true;
                }
                this.setState({
                  showStartEndDate,
                  startDate,
                  endDate,
                  sendStartTime: startDate,
                  sendEndTime: endDate,
                  selectedValues: {
                    ...this.state.selectedValues,
                    DatesBy: selected || null,
                  },
                  DatesBy: selected,
                });
              }}
            />
          </SelectStyle>
        </div>

        {this.state.showStartEndDate && (
          <div
            className="row w-100 px-4 py-4 m-0 mb-3"
            style={{
              backgroundColor: "#f2f2f2",
            }}
          >
            <div className="filter-row mb-3 col-md-6">
              <FlexItem>
                <ControlLabel>Start date</ControlLabel>
                <Datetime
                  inputProps={{ readOnly: true }}
                  value={this.state.sendStartTime}
                  onChange={(date) => {
                    if (
                      parseInt(
                        moment(date)
                          .tz(zone.value)
                          .format("X")
                      ) *
                      1000 <
                      this.state.sendEndTime
                    )
                      that.setState(
                        {
                          sendStartTime:
                            parseInt(
                              moment(date)
                                .tz(zone.value)
                                .format("X")
                            ) * 1000,
                        },
                        () => {
                        }
                      );
                  }}
                />
                <span
                  class="icon material-symbols-outlined"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "30px",
                    color: "#D9D9D9",
                  }}
                >
                  calendar_month
                </span>
              </FlexItem>
            </div>
            <div className="filter-row mb-3 col-md-6">
              <FlexItem>
                <ControlLabel>End date</ControlLabel>
                <Datetime
                  className="datatime-wrapper datetime-wrapper-move-left"
                  inputProps={{ readOnly: true }}
                  value={this.state.sendEndTime}
                  onChange={(date) => {
                    if (
                      parseInt(
                        moment(date)
                          .tz(zone.value)
                          .format("X")
                      ) *
                      1000 >
                      this.state.sendStartTime
                    ) {
                      this.setState({
                        sendEndTime:
                          parseInt(
                            moment(date)
                              .tz(zone.value)
                              .format("X")
                          ) * 1000,
                      });
                    }
                  }}
                />
                <span
                  class="icon material-symbols-outlined"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "30px",
                    color: "#D9D9D9",
                  }}
                >
                  calendar_month
                </span>
              </FlexItem>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }

  renderDropdown(label, placeholder, key, apiUrl, addFilter = "") {
    const { __ } = this.context;
    let _this = this;

    return (
      <div className="filter-row mb-3 px-5">
        <ControlLabel>{label}</ControlLabel>
        <SelectStyle>
          <SelectFilterAPI
            // limit={this.props.limit || 200}
            dataUrl={apiUrl}
            selected={this.state.selectedValues[key] || []}
            initialValues={this.state.selectedValues[key] || []}
            addFilter={addFilter}
            label={placeholder}
            name={""}
            multi={true}
            onSelect={(data, name, selected) => {
              this.setState({
                selectedValues: {
                  ...this.state.selectedValues,
                  [key]: selected,
                }, // data= array of values(id), key= breakIds,
              });
            }}
          />
        </SelectStyle>
      </div>
    );
  }
  renderFormGroup(label, placeholder, type, key) {
    return (
      <div className="filter-row mb-3 px-5">
        {/* <ItemSearch> */}
        <ControlLabel>{label}</ControlLabel>
        <FormStyle>
          <FormControl
            type="text"
            defaultValue=""
            placeholder={placeholder}
            id="from"
            value={this.state.selectedValues[key] || ""}
            onChange={(e) => {
              const value =
                e.target.value && !e.target.value.trim() ? "" : e.target.value;
              if (type === "number" && !/^\d*$/.test(value)) {
                return e.preventDefault();
              }
              this.setState({
                selectedValues: {
                  ...this.state.selectedValues,
                  [key]: value,
                },
              });
            }}
          />
        </FormStyle>
        {/* </ItemSearch> */}
      </div>
    );
  }
  renderSelect(label, placeholder, key, list, multi = true) {
    return (
      /* <FlexItem className='filter-row'> */
      <div className="filter-row mb-3 px-5">
        <ControlLabel>{label}</ControlLabel>
        <SelectStyle>
          <Select
            placeholder={placeholder}
            onChange={(data) => {
              let selected;
              if (multi) {
                selected = [];
                if (data) {
                  selected = data.map((e) => e.value);
                }
              } else {
                if (data && typeof data === "object") {
                  selected = data.value || data;
                } else {
                  selected = data || "";
                }
              }
              this.setState({
                selectedValues: {
                  ...this.state.selectedValues,
                  [key]: selected,
                },
              });
            }}
            value={this.state.selectedValues[key] || (multi ? [] : null)}
            options={this.generateProjectParams(list)}
            multi={multi}
          />
        </SelectStyle>
      </div>
      /* </FlexItem> */
    );
  }
  renderEndDateOnly(options = {}) {
    let zone = commonManager.getTimeZone();
    return (
      <div className="filter-row mb-3 px-5">
        <ControlLabel>Select date</ControlLabel>
        <Datetime
          {...options}
          className="datatime-wrapper datetime-wrapper-move-left"
          inputProps={{ readOnly: true }}
          value={this.state.sendEndTime}
          onChange={(date) => {
            this.setState({
              sendEndTime:
                parseInt(
                  moment(date)
                    .tz(zone.value)
                    .format("X")
                ) * 1000,
            });
          }}
        />
        <span
          class="icon material-symbols-outlined"
          style={{
            position: "absolute",
            right: 40,
            top: 40,
            color: "#D9D9D9",
          }}
        >
          calendar_month
        </span>
      </div>
    );
  }

  resetAllData() {
    let filterDurationOptions = [
      { value: "today", label: "Today" },
      { value: "last24", label: "Last 24 Hrs" },
      { value: "yesterday", label: "Yesterday" },
      { value: "lastweek", label: "Last 7 Days" },
    ];

    let zone = commonManager.getTimeZone();

    let filterDurationObject;

    if (
      this.state.isSummary !== -1 &&
      this.props.notReportInFirstPlace !== true
    ) {
      // this is for summary report for today select
      filterDurationObject = { value: "today", label: "Today" };
    } else {
      let filterDuration = localStorage.getItem("filterDuration");

      filterDurationObject = filterDurationOptions.find(
        (item) => item.value === filterDuration
      );
    }

    let selected =
      filterDurationObject && filterDurationObject.label
        ? filterDurationObject.label
        : "";

    if (!selected) {
      this.setState({
        showStartEndDate: false,
        startDate: "",
        endDate: "",
        sendStartTime: "",
        sendEndTime: "",
        DatesBy: null,
        selectedValues: {
          // ...this.state.selectedValues,
          DatesBy: null,
        },
      });
      this.props.getData({});
      return;
    }
    const {
      startDate: startDate_Dur,
      endDate: endDate_Dur,
    } = commonManager.calculateTimeRange(selected, zone);
    this.setState({
      showStartEndDate: false,
      startDate: startDate_Dur,
      endDate: endDate_Dur,
      sendStartTime: startDate_Dur,
      sendEndTime: endDate_Dur,
      DatesBy: selected || null,
      timezone: zone,
      selectedValues: {
        // ...this.state.selectedValues,
        DatesBy: selected || null,
        timezone: zone,
      },
    });

    let tData = {
      timezone: zone,
      sendStartTime: startDate_Dur,
      sendEndTime: endDate_Dur,
      startDate: startDate_Dur,
      endDate: endDate_Dur,
      DatesBy: selected || null,
      // ...this.state.selectedValues,
    };

    this.setState({
      selectedValues: tData,
    });
    this.props.getData(tData);
  }

  checkField(field) {
    const { filterList = [] } = this.props;
    return filterList && filterList.indexOf(field) > -1 ? true : false;
  }

  renderFilter(type) {
    const { reportName = "", showAgentsOnly = false } = this.props;

    const reportsToHide = [
      "agent-outbound-cdr-report",
      "agent-inbound-cdr-report",
      "agent-outbound-drop-report",
      "agent-inbound-missed-report",
    ];
    let filter = null;
    switch (type) {
      case "renderTo":
        filter = this.renderFormGroup(
          "Customer Number",
          "Enter Customer Number",
          "number",
          "to"
        );
        break;
      case "renderIdentification":
        filter = this.renderFormGroup(
          "Identification",
          "Enter Identification",
          "text",
          "identification"
        );
        break;
      case "renderSessionID":
        filter = this.renderFormGroup(
          "Session ID",
          "Enter Session ID",
          "text",
          "sessionIds"
        );
        break;
      case "renderCustomerID":
        filter = this.renderFormGroup(
          "Customer ID",
          "Enter Customer ID",
          "text",
          "customerId"
        );
        break;
      case "renderResolutionStatus":
        filter = this.renderFormGroup(
          "Resolution Status",
          "Enter Resolution Status",
          "text",
          "resolutionStatus"
        );
        break;
      case "renderFirstLevelTag":
        filter = this.renderFormGroup(
          "First Level Tag",
          "Enter First Level Tag",
          "text",
          "firstLevelTag"
        );
        break;
      case "renderSecondLevelTag":
        filter = this.renderFormGroup(
          "Second Level Tag",
          "Enter Second Level Tag",
          "text",
          "secondLevelTag"
        );
        break;
      case "renderThirdLevelTag":
        filter = this.renderFormGroup(
          "Third Level Tag",
          "Enter Third Level Tag",
          "text",
          "thirdLevelTag"
        );
        break;
      case "renderFrom":
        filter = this.renderFormGroup(
          "DNIS / Caller ID",
          "Enter DNIS or Caller ID",
          "number",
          "source"
        );
        break;
      case "renderCauseCode":
        filter = this.renderFormGroup(
          "Cause Code",
          "Enter Cause Code",
          "number",
          "causeCode"
        );
        break;
      case "renderFreetext":
        filter = this.renderFormGroup(
          "Free Text",
          "Enter Free Text",
          "text",
          "freeTextSearch"
        );
        break;
      case "renderPhoneNumberText":
        filter = this.renderFormGroup(
          "Phone Number",
          "Enter Phone Number",
          "number",
          "phoneNumber"
        );
        break;
      case "renderUser":
        filter = this.renderDropdown(
          "User",
          "Select User",
          this.state.reportType === "cdr" ? "userIds" : "agentId",
          "user",
          reportsToHide.includes(reportName) || showAgentsOnly ? "&role=6" : ""
        );
        break;
      case "renderProvider":
        filter = this.renderDropdown(
          "Provider",
          "Select Provider",
          "provider",
          "setting/telephony"
        );
        break;
      case "renderPhoneNumber":
        filter = this.renderDropdown(
          "Phone Number",
          "Select Phone number",
          "phoneNumber",
          "setting/phone-number"
        );
        break;
      case "renderBotName":
        filter = this.renderDropdown(
          "Bot Name",
          "Select Bot Name",
          "flow",
          "setting/flow",
          "&type=message"
        );
        break;
      case "renderChatStatus":
        filter = this.renderSelect(
          "Chat Status",
          "Select Chat Status",
          "chatStatus",
          [
            { _id: "assigned", name: "Assigned" },
            { _id: "flow", name: "Flow" },
            { _id: "queue", name: "Queue" },
            { _id: "closed", name: "Closed" },
          ]
        );
        break;
      case "renderPlatform":
        filter = this.renderSelect(
          "Platform",
          "Select Platform",
          "platform",
          [
            { _id: "rcs", name: "RCS" },
            { _id: "whatsapp", name: "Whatsapp" },
            { _id: "webchat", name: "Webchat" },
            { _id: "instagram", name: "Instagram" },
            { _id: "facebook", name: "Facebook" },
            { _id: "telegram", name: "Telegram" },
            { _id: "sms", name: "SMS" },
            { _id: "cpaas", name: "CPASS" },
            { _id: "other", name: "Other" },
          ]
        );
        break;
      case "renderStickyAgent":
        filter = this.renderDropdown(
          "Users",
          "Select Users",
          "stickyAgent",
          "user",
          reportsToHide.includes(reportName) || showAgentsOnly ? "&role=6" : ""
        );
        break;
      case "renderBreak":
        filter = this.renderDropdown(
          "Break",
          "Select Break",
          "breakIds",
          "setting/break"
        );
        break;
      case "renderCampaign":
        const { currentUser } = this.props;
        if (currentUser && currentUser.role === 6) {
          return;
        }
        filter = this.renderDropdown(
          "Campaign",
          "Select Campaign",
          "campaignIds",
          "campaign",
          "&type=voice"
        );
        break;
      case "renderMsgCampaign":
        // const { currentUser } = this.props;
        if (this.props.currentUser && this.props.currentUser.role === 6) {
          return;
        }
        filter = this.renderDropdown(
          "Campaign",
          "Select Campaign",
          "campaignIds",
          "campaign",
          "&type=message"
        );
        break;
      case "renderDisposition":
        filter = this.renderDropdown(
          "Disposition",
          "Select Disposition",
          "desposeIds",
          "despose"
        );
        break;
      // case 'renderDisposition':
      //   filter = this.renderDropdown('Tag', 'Select Tag', 'tagIds', 'despose');
      //   break;
      case "renderContactList":
        filter = this.renderDropdown(
          "Contact List",
          "Select Contact List",
          "contactListIds",
          "contact/contact-list/list"
        );
        break;
      case "renderTeam":
        filter = this.renderDropdown(
          "Team",
          "Select Team",
          "teamIds",
          "team/list"
        );
        break;
      case "renderCallingMode":
        filter = this.renderSelect(
          "Calling Mode",
          "Select Calling Mode",
          "mode",
          [
            { _id: "preview", name: "Preview" },
            { _id: "Progressive", name: "Progressive" },
            { _id: "broadcast", name: "Broadcast" },
            { _id: "manual", name: "Manual" },
            { _id: "incomming", name: "Incomming" },
          ]
        );
        break;
      case "renderDropReason":
        filter = this.renderSelect(
          "Drop Reason",
          "Select Drop Reason",
          "dropReason",
          [
            { _id: "AGENT", name: "AGENT" },
            { _id: "FAILED", name: "FAILED" },
            { _id: "DROP", name: "DROP" },
            { _id: "MISSED", name: "MISSED" },
            { _id: "IVR_DROP", name: "IVR DROP" },
            { _id: "QUEUE_DROP", name: "QUEUE DROP" },
            { _id: "AMD", name: "AMD" },
            { _id: "NOT_IDENTIFY", name: "NOT IDENTIFY" },
          ]
        );
        break;
      case "renderOutboundDropReason":
        filter = this.renderSelect(
          "Outbound Drop Reason",
          "Select Outbound Drop Reason",
          "dropReason",
          [
            { _id: "FAILED", name: "FAILED" },
            { _id: "DROP", name: "DROP" },
          ]
        );
        break;
      case "renderMissedReason":
        filter = this.renderSelect(
          "Missed Reason",
          "Select Missed Reason",
          "dropReason",
          [
            { _id: "MISSED", name: "MISSED" },
            { _id: "IVR_DROP", name: "IVR DROP" },
            { _id: "QUEUE_DROP", name: "QUEUE DROP" },
          ]
        );
        break;
      case "renderCallType":
        filter = this.renderSelect(
          "Call Type",
          "Select Call Type",
          "callType",
          [
            { _id: "Cpass", name: "Cpass" },
            { _id: "Auto", name: "Auto" },
            { _id: "broadcast", name: "Broadcast" },
            { _id: "manual", name: "Manual" },
            { _id: "Inbound", name: "Inbound" },
          ]
        );
        break;
      case "renderCallSubType":
        filter = this.renderSelect(
          "Call Subtype",
          "Select Call Subtype",
          "callSubType",
          [
            { _id: "Missed", name: "Missed" },
            { _id: "IVR", name: "IVR" },
            { _id: "Queue", name: "Queue" },
            { _id: "CallStart", name: "Call Start" },
            { _id: "Answered", name: "Answered" },
            { _id: "CallTag", name: "Call Tag" },
            { _id: "Failed", name: "Failed" },
            { _id: "Drop", name: "Drop" },
            { _id: "Success", name: "Success" },
            { _id: "CallEnd", name: "Call End" },
          ]
        );
        break;
      case "renderIntegration":
        filter = this.renderSelect(
          "Integration",
          "Select Integration",
          "integration",
          [
            { _id: "WebHooks", name: "WebHooks" },
            { _id: "Leadsqured", name: "Leadsqured" },
          ]
        );
        break;
      case "renderEndDateOnly":
        filter = this.renderEndDateOnly(this.props.endDatePickerOptions);
        break;
      case "renderInterval":
        filter = this.renderSelect(
          "Interval",
          "Select Interval",
          "interval",
          [
            { name: "24 hours", _id: "1440" },
            { name: "12 hours", _id: "720" },
            { name: "6 hours", _id: "360" },
            { name: "1 hour", _id: "60" },
            { name: "30 mins", _id: "30" },
            { name: "15 mins", _id: "15" },
            { name: "10 mins", _id: "10" },
            { name: "5 mins", _id: "5" },
          ],
          false
        );
        break;
      case "renderOperation":
        filter = this.renderSelect(
          "Operation",
          "Select Operation",
          "operation",
          [
            { name: "Import", _id: "Import" },
            { name: "Create", _id: "Create" },
            { name: "Update", _id: "Update" },
            { name: "Delete", _id: "Delete" },
          ],
          true
        );
        break;
      case "renderModuleName":
        filter = this.renderFormGroup(
          "Module Name",
          "Enter Module Name",
          "text",
          "module"
        );
        break;
      case "renderModuleNameLogs":
        filter = this.renderSelect(
          "Module Name",
          "Select Module Name",
          "module",
          this.props.logModuleNameOptions,
          true
        );
        break;
      case "renderImportExportType":
        filter = this.renderSelect(
          "Type",
          "Select Type",
          "action",
          [
            { name: "Import", _id: "Import" },
            { name: "Export", _id: "Export" },
          ],
          false
        );
        break;
      default:
        filter = null;
    }
    if (filter) {
      return filter;
    } else {
      return <React.Fragment />;
    }
  }
  render() {
    const { __ } = this.context;
    const { filterList = [] } = this.props;
    const props = {
      inputProps: { placeholder: __("Click to select a date") },
      timeFormat: "HH:mm",
      dateFormat: "YYYY/MM/DD",
    };
    return (
      <InsightFilter className="p-0 overflow-hidden">
        <ModalForm
          onSubmit={(e) => this.onSubmit(e)}
          style={{ zIndex: "99", position: "relative" }}
          className="h-100"
        >
          <div
            style={{ height: "calc(100% - 86px)" }}
            className="labelFontWeight700Important py-5 m-0 w-100 overflow-auto"
          >
            {filterList.map((type) => {
              return (
                <React.Fragment>
                  {type === "renderTimezones"
                    ? this.renderTimezones()
                    : type === "renderTimezonesOnly"
                      ? this.renderTimezonesOnly()
                      : type === "renderTimezonesFuture"
                        ? this.renderTimezonesFuture()
                        : this.renderFilter(type)}
                </React.Fragment>
              );
            })}
          </div>
          <FlexItem
            className="filter-btn conainer-fluid m-0 w-100 bg-white er bottom-0"
            style={{
              "box-shadow": "0px -5px 20px rgba(0, 0, 0, 0.1)",
              padding: "20px",
              height: "86px",
            }}
          >
            <ButtonCommonTheme
              type="greyModalBtn"
              className="FilterModalBtn"
              //icon="refresh"
              OnClick={this.resetAllData}
            >
              Reset
            </ButtonCommonTheme>
            <ButtonCommonTheme
              type="blueModalBtn"
              className="FilterModalBtn"
              // icon="filter"
              btnType="submit"
            >
              {this.state.isLoading ? (
                <Spinner
                  style={{
                    height: "2px",
                    width: "2px",
                    marginTop: "-15px",
                    padding: "10px",
                    marginBottom: "10px",
                  }}
                />
              ) : (
                "Apply"
              )}
            </ButtonCommonTheme>
          </FlexItem>
        </ModalForm>
      </InsightFilter>
    );
  }
}

CommonFilter.contextTypes = contextTypes;

const stateToProps = (state) => ({
  currentUser: globalStateSelector.getDynamic(state, { key: "currentUser" }),
});

export default connect(stateToProps)(CommonFilter);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/CommonFilter.js